import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, getcountries, getReceiptId, getinvoiceregType, geteventType, getseriesType, getconferenceEvent, getwebinarEvent} from '../../../services/event/invoiceReceiptForm/invoiceReceiptServices';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import Swal from 'sweetalert2';

const subDomain = localStorage.getItem('sub_domain') || '';

const InvoiceReceipt = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({
    id: '',
    invoice_id : '',
    invoice_date : '',
    registration_type : '',
    reg_amount : '',
    no_of_ticket : '',
    currency : '',
    payment_mode : '',
    billing_name : '',
    billing_address : '',
    billing_phone_no : '',
    billing_country : '',
    billing_email : '',
    vat_number : '',
    series : '',
    event_title: '',
    event_date: '',
    event_type: '',
    pdf_status : 0,
    sub_domain : subDomain,
    subject: '',
    updatedAt : ''
  });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [showViewModal, setShowViewModal] = useState(false);
  const [errors, setErrors] = useState({});
  
  // Filter States
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [dropdownData, setDropdownData] = useState({
    invoiceregType: [],
    eventType: [],
    countries: []
  });
 const [loading, setLoading] = useState(true);
 
  // Fetch all dropdown data
  const fetchDropdownData = useCallback(async () => {
    try {
      const [invoice, event, country] = await Promise.all([
        getinvoiceregType(),
        geteventType(),
        getcountries()
      ]);
 
      setDropdownData({
        invoiceregType: invoice,
        eventType: event,
        countries: country
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);
 
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({sub_domain: subDomain });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);
  const fetchReceiptId = useCallback(async (type) => {
      try {
          const result = await getReceiptId({ sub_domain: subDomain, type });
          console.log('Result:', result);
   
          if (result && result[type]) {
            setForm((prevForm) => ({
              ...prevForm,
              invoice_id: result[type]
            }));
          }
      } catch (error) {
          console.error('Error fetching payment ID:', error);
      }
  }, []);

  const fetchseriesType = useCallback(async () => {
      try {
        const data = await getseriesType({ sub_domain: subDomain });
        if (data && data.length > 0) {
          const seriesInfo = data[0]; // Assuming you're using the first item
          setForm(prev => ({
            ...prev,
            series: seriesInfo.series || '',
            venue: seriesInfo.venue || ''
          }));
        }
      } catch (error) {
        console.error('Failed to fetch series info:', error);
      }
    }, []);

  useEffect(() => {
    
    // fetchReceiptId();
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      await fetchDropdownData();
      await fetchseriesType();
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
 
  }, [fetchData, fetchDropdownData, fetchReceiptId, fetchseriesType]);
  
  const handleChange = async (e) => {
  const { name, value } = e.target;
  setForm((prev) => ({ ...prev, [name]: value }));
  setErrors((prev) => ({ ...prev, [name]: '' }));
  
  //event title and date , venu
  if (name === 'event_type') {
    let eventData = [];
    try {
      if (value.toLowerCase() === 'conference') {
        eventData = await getconferenceEvent({ sub_domain: subDomain });
      } else if (value.toLowerCase() === 'webinar') {
        eventData = await getwebinarEvent({ sub_domain: subDomain });
      }

      if (eventData.length > 0) {
        const event = eventData[0]; // assume first result
        const eventDate = formatEventDate(event.from_date, event.to_date, value === 'conference' ? event.venue : '');
        
        setForm((prev) => ({
          ...prev,
          event_title: event.event_title,
          event_date: eventDate
        }));
      }
    } catch (error) {
      console.error('Error loading event details:', error);
    }
  }
};

//event title and date and venue
  const formatEventDate = (fromDate, toDate, venue = '') => {
  const from = new Date(fromDate);
  const to = new Date(toDate);

  const options = { month: 'long', day: '2-digit' };
  const fromFormatted = from.toLocaleDateString('en-US', options);
  const toFormatted = to.toLocaleDateString('en-US', { day: '2-digit' });

  const year = from.getFullYear();
  const range = `${fromFormatted}-${toFormatted}, ${year}`;
  return venue ? `${range} | ${venue}` : range;
};


  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
        'invoice_date',
        'registration_type',
        'reg_amount',
        'no_of_ticket',
        'currency',
        'payment_mode',
        'billing_name',
        'billing_address',
        'billing_phone_no',
        'billing_country',
        'event_type',
        'series'
    ];

    requiredFields.forEach((field) => {
      if (!String(form[field] || '').trim()) {
          newErrors[field] = 'Please fill out this field';
      }
  });
  

    // Email format validation
    if (form.billing_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.billing_email)) {
        newErrors.billing_email = 'Enter a valid email';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};
 
  const handleSubmit = async () => {
    if (!validateForm()) return;
    try {
      // Submit the form data
      if (modalType === 'add') {
        await addData(form);
      } else if (modalType === 'edit') {
        await updateData({ ...form, pdf_status: 0 }); // ✅ Set pdf_status to 0 on update

      }
      fetchData();
      setShowModal(false);
    // ✅ Show success alert with auto-close
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: `Invoice Receipt ${modalType === 'add' ? 'added' : 'updated'} successfully!`,
        timer: 2000, // 2 seconds
        showConfirmButton: false,
      });

    } catch (error) {
      console.error('Error during form submission:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while submitting the form!',
      });
    }
  };
const getTodayDate = () => {
  return new Date().toISOString().split('T')[0]; // returns 'YYYY-MM-DD'
};
const todayDate = getTodayDate(); 

const openModal = async (type, data = {
    id: '',
    invoice_id: '',
    invoice_date: todayDate,
    registration_type: '',
    reg_amount: '',
    no_of_ticket: '',
    currency: '',
    payment_mode: '',
    billing_name: '',
    billing_address: '',
    billing_phone_no: '',
    billing_country: '',
    billing_email: '',
    vat_number: '',
    series: '',
    event_title: '',
    event_date: '',
    event_type: '',
    sub_domain: subDomain,
    subject: '',
    updatedAt: ''
  }) => {
    setErrors({}); // ✅ Clear previous errors
    setModalType(type);
    setForm(data);
  
    if (type === 'add') {
      try {
        const result = await getReceiptId({ sub_domain: data.sub_domain, type: 'invoice' });
        if (result && result.invoice_id) {
          data.invoice_id = result.invoice_id;
        }
        const seriesData = await getseriesType({ sub_domain: subDomain });
        if (seriesData?.length > 0) {
          data.series = seriesData[0].series;
        }  
      } catch (error) {
        console.error("Error fetching receipt ID:", error);
      }
    }
  
    setForm(data);
  
    if (type === 'add' || type === 'edit') {
      setShowModal(true); // Show the Add/Edit Modal
    } else if (type === 'view') {
      setShowViewModal(true); // Show the View Modal
    }
  };
  
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };
 
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const getCurrencySymbol = (currencyCode) => {
  switch (currencyCode?.toUpperCase()) {
    case 'USD': return '$';
    case 'EUR': return '€';
    case 'INR': return '₹';
    case 'GBP': return '£';
    case 'RUB': return '₽';
    case 'THB': return '฿';
    default: return currencyCode || '';
  }
};
   //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
  const startDateObj = startDate ? new Date(startDate) : null;
  const endDateObj = endDate ? new Date(endDate) : null;

  return dataList
    .filter((data) => {
      // Text-based search
      const matchesText =
        data.billing_name.toLowerCase().includes(searchText.toLowerCase()) ||
        data.reg_amount.toString().includes(searchText.toLowerCase()) ||
        data.billing_country.toLowerCase().includes(searchText.toLowerCase());

      // Date range filtering
      const date = data.invoice_date ? new Date(data.invoice_date) : null;
      const inDateRange = (startDateObj && endDateObj)
        ? date >= startDateObj && date <= endDateObj
        : true;

      // Country filtering
      const matchCountry = !countryFilter || data.billing_country === countryFilter;

      return matchesText && inDateRange && matchCountry;
    })
    .sort((a, b) => new Date(b.invoice_date) - new Date(a.invoice_date)); // Always sort by date descending
}, [dataList, searchText, startDate, endDate, countryFilter]);

 
  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '60px',
    },
    {
      name: 'Invoice Date',
      selector: (row) => row.invoice_date,
      sortable: true,
    },
    {
      name: 'Name',
      selector: (row) => row.billing_name,
      sortable: true,
    },
    {
      name: 'Country',
      selector: (row) => getCountryName(row.billing_country),
      sortable: true,
    },
    {
      name: 'Reg Amount',
      selector: (row) => {
        const currencySymbol = getCurrencySymbol(row.currency);
        return <b className='fs-4'>{currencySymbol} {row.reg_amount}</b>;
      },
      sortable: true,
    },
    {
      name: 'Invoice Id',
      selector: (row) => row.invoice_id,
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
    <Button variant="primary" size="sm" onClick={() => openModal('view', row)} className="me-2">
    <i className="align-middle far fa-fw fa-eye"></i>
    </Button>

    <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
        </div>
      ),
    },
  ];
 
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        <div className=" row m-3 d-flex flex-column gap-3 ">
          <div className="d-flex gap-2">
            {/* Dropdown for Filters */}
            <div className="col-md-2">
            <span>Countries</span>
            <select
              className="form-control"
              value={countryFilter}
              onChange={(e) => setCountryFilter(e.target.value)}
            >
              <option value="">All Countries</option>
              {dropdownData.countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>

            {/* Start Date and End Date Input */}
            <div className="col-md-2">
              <span>Start Date</span>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <span>End Date</span>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>

        
        </div>
        {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center w-100"
                  style={{ minHeight: "300px" }}
                >
                  <Spinner /> {/* Centered Spinner */}
                </div>
                        ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
            <p className='fs-4'>Receipt Generation / Invoice Generation Form</p>
            </div>
            <div className="col-4 text-end">
            <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
            </button>
            </div>
          </div>
 
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />
 
          {/* Modal for Add/Edit data */}
          <Modal show={showModal} className='modal-xl' onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <div className='row'>
                <Form.Group className="col-md-3 mb-3">
                <Form.Label>Invoice ID<span className="text-danger">*</span></Form.Label>
                <Form.Control type="text" name="invoice_id" value={form.invoice_id}  readOnly/>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label>Series<span className="text-danger">*</span></Form.Label>
                  <Form.Control type="text" name="series" value={form.series} readOnly />
                </Form.Group>    
                <Form.Group className="col-md-3 mb-3">
                    <Form.Label>Event Type<span className="text-danger">*</span></Form.Label>
                    <Form.Select name="event_type" value={form.event_type} onChange={handleChange} isInvalid={!!errors.event_type}>
                      <option value="">Select</option>
                      {dropdownData.eventType.map((eventType) => (
                        <option key={eventType.type} value={eventType.type}>
                          {eventType.type}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">  {errors.event_type} </Form.Control.Feedback>
                  </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label>Invoice Date<span className="text-danger">*</span></Form.Label>
                  <Form.Control type="date" name="invoice_date" value={form.invoice_date} onChange={handleChange}  isInvalid={!!errors.invoice_date}/>
                  <Form.Control.Feedback type="invalid">  {errors.invoice_date} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                    <Form.Label>Registration Type<span className="text-danger">*</span> </Form.Label>
                    <Form.Select name="registration_type" value={form.registration_type} onChange={handleChange} isInvalid={!!errors.registration_type}>
                      <option value="">Select</option>
                      {dropdownData.invoiceregType.map((invoiceregType) => (
                        <option key={invoiceregType.type} value={invoiceregType.type}>
                          {invoiceregType.type}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">  {errors.registration_type} </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="col-md-3 mb-3">
                  <Form.Label>Registration Amount<span className="text-danger">*</span></Form.Label>
                  <Form.Control type="text" name="reg_amount" value={form.reg_amount} onChange={handleChange} isInvalid={!!errors.reg_amount}/>
                  <Form.Control.Feedback type="invalid">  {errors.reg_amount} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label>No. of Ticket<span className="text-danger">*</span></Form.Label>
                  <Form.Control type="number" name="no_of_ticket" value={form.no_of_ticket} onChange={handleChange} isInvalid={!!errors.no_of_ticket}/>
                  <Form.Control.Feedback type="invalid">  {errors.no_of_ticket} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                    <Form.Label>Payment Mode <span className="text-danger">*</span></Form.Label>
                    <Form.Control as="select" name="payment_mode" value={form.payment_mode} onChange={handleChange} isInvalid={!!errors.payment_mode}>
                    <option value="">-- Select --</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">  {errors.payment_mode} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                    <Form.Label>Choose the Currency</Form.Label>
                    <Form.Control as="select" name="currency" value={form.currency} onChange={handleChange} isInvalid={!!errors.currency}>
                    <option value="">-- Select --</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="INR">INR</option>
                    <option value="RUB">RUB</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">  {errors.currency} </Form.Control.Feedback>
                </Form.Group>
                
                </div>
                
                <div className='row'>
                <div className="col-md-12">
                    <h5>Billing Address</h5>
                </div>
                </div>
 
                <div className='row'>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label>Full Name<span className="text-danger">*</span></Form.Label>
                  <Form.Control type="text" name="billing_name" value={form.billing_name} onChange={handleChange} isInvalid={!!errors.billing_name}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_name} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label>Email<span className="text-danger">*</span></Form.Label>
                  <Form.Control type="email" name="billing_email" value={form.billing_email} onChange={handleChange} isInvalid={!!errors.billing_email}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_email} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label>Phone No<span className="text-danger">*</span></Form.Label>
                  <Form.Control type="number" name="billing_phone_no" value={form.billing_phone_no} onChange={handleChange} isInvalid={!!errors.billing_phone_no}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_phone_no} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-5 mb-3">
                    <Form.Label>Choose the Country<span className="text-danger">*</span></Form.Label>
                    <Form.Control className="form-select mb-3" as="select" name="billing_country" value={form.billing_country} onChange={handleChange} isInvalid={!!errors.billing_country}>
                        <option value="">Select</option>
                        {dropdownData.countries.map((country) => (
                            <option key={country.code} value={country.code}>
                            {country.name}
                            </option>
                        ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">  {errors.billing_country} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-5 mb-3">
                  <Form.Label>Address<span className="text-danger">*</span></Form.Label>
                  <Form.Control type="text" name="billing_address" value={form.billing_address} onChange={handleChange} isInvalid={!!errors.billing_address}/>
                  <Form.Control.Feedback type="invalid">  {errors.billing_address} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-2 mb-3">
                  <Form.Label>VAT</Form.Label>
                  <Form.Control type="text" name="vat_number" value={form.vat_number} onChange={handleChange} />
                </Form.Group>
                </div>              
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
          </Modal>
 
          {/* View Modal */}
          <Modal className="modal-lg" show={showViewModal} onHide={() => setShowViewModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>View Receipt Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table striped bordered hover responsive className="table-sm">
                <thead>
                    <tr><th colSpan={2} className="bg-secondary text-white">Payment Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Event Type</td><td>{form.event_type}</td></tr>
                    <tr><td>Invoice Date</td><td>{form.invoice_date}</td></tr>
                    <tr><td>Invoice ID</td><td>{form.invoice_id}</td></tr>
                    <tr><td>Registration Type</td><td>{form.registration_type}</td></tr>
                    <tr><td>Amount</td><td>{form.reg_amount}</td></tr>
                    <tr><td>No. of Tickets</td><td>{form.no_of_ticket}</td></tr>
                </tbody>

                <thead>
                    <tr><th colSpan={2} className="bg-secondary text-white">Billing Address</th></tr>
                </thead>
                <tbody>
                    <tr><td>Full Name</td><td>{form.billing_name}</td></tr>
                    <tr><td>Email</td><td>{form.billing_email}</td></tr>
                    <tr><td>Phone No</td><td>{form.billing_phone_no}</td></tr>
                    <tr><td>Address</td><td>{form.billing_address}</td></tr>
                    <tr><td>Country</td><td>{form.billing_country}</td></tr>
                </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowViewModal(false)}>Close</Button>
            </Modal.Footer>
            </Modal>

        </div>
        <Footer />
        </div>
      )};
      </div>
    </div>
  );
};
 
export default InvoiceReceipt;